<template>
  <div class="page_custEmp">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="姓名" size="small">
              <el-input v-model="listQuery.employeeName" size="small" style="width:120px"></el-input>
            </el-form-item>
            <el-form-item label="联系方式" size="small">
              <el-input v-model="listQuery.phoneNum" size="small" style="width:120px"></el-input>
            </el-form-item>
            <el-form-item label="身份证号码" size="small">
              <el-input v-model="listQuery.cardId" size="small" style="width:120px"></el-input>
            </el-form-item>
            <el-form-item label="归属月" size="small">
              <el-date-picker v-model="listQuery.attrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 120px;">
              </el-date-picker>
            </el-form-item>
            <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-left: 15px;">搜索</el-button>
          </el-form>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>{{activeName}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="汇总" name="汇总"></el-tab-pane>
          <el-tab-pane label="发放成功明细" name="发放成功明细"></el-tab-pane>
          <el-tab-pane label="发放失败明细" name="发放失败明细"></el-tab-pane>
        </el-tabs>
        <div style="margin-bottom: 10px;" class="flex">
          <el-button type="primary" size="small" :loading="isExping" @click="expList()">导出</el-button>
          <el-button type="warning" size="small" :loading="isExping2" @click="batchDown()">批量下载回单</el-button>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%">
          <el-table-column label="序号" key="0" prop="No" min-width="60" fixed="left" align="center">
            <template slot-scope="{$index}">{{ (listQuery.pageModel.page - 1) * listQuery.pageModel.rows + ($index + 1) }}</template>
          </el-table-column>
          <el-table-column label="发薪编号" key="1" prop="payrollNum" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="归属月" key="2" prop="attrMonth" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="申报月" key="3" prop="incomeTaxMonth" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="发放主体" key="4" prop="payrollCompany" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="项目名称" key="5" prop="projectName" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="员工姓名" key="6" prop="employeeName" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="身份证号码" key="7" prop="cardID" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="实发金额" key="8" prop="issuedThisMonth" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="银行账号" key="9" prop="bankAccount" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="开户行" key="10" prop="depositBank" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column label="开户地" key="11" prop="ProjectName" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column label="发薪类型" key="12" prop="payType" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="备注" key="13" prop="remark" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <!-- <el-table-column label="发薪申请备注" key="14" prop="ProjectName" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column> -->
          <el-table-column label="发放时间" key="15" prop="paymentTime" min-width="160" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.paymentTime ? row.paymentTime.replace('T',' ') : '' }}</template>
          </el-table-column>
          <el-table-column label="发薪状态" key="16" prop="processState" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" min-width="100" align="center" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" v-if="row.processState =='已发薪' && checkPermission(['custSalary_downReceipt'],permissionLists)" @click="downReceiptSingle(row)">下载回单</el-button>
                <!-- <el-button type="text" v-if="row.processState=='发薪失败'" @click="editFailInfo(row)">修改提交</el-button> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.pageModel.page" :page-size="Number(listQuery.pageModel.rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog title="修改" :visible.sync="showEditFailInfo" width="550px">
      <el-form :model="formData" ref="formData" :rules="rules" label-width="110px" v-if="showEditFailInfo">
        <el-form-item label="商务合同主体">
          <div class="formItem">{{info.Subject}}</div>
        </el-form-item>
        <el-form-item label="客户名称">
          <div class="formItem">{{info.CustomerName}}</div>
        </el-form-item>
        <el-form-item label="姓名" prop="EmployeeName">
          <el-input v-model="formData.EmployeeName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="应发金额">
          <el-input v-model="info.IncludesTelephoneSubsidy" style="width:300px" size="small" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="实发金额">
          <div class="flex">
            <el-input v-model="info.IssuedThisMonth" style="width:300px" size="small" readonly disabled></el-input>
            <el-button type="text" @click="splitPay" v-if="info.PayErrMsg!=undefined && info.PayErrMsg && (info.PayErrMsg.indexOf('限额')>-1 || info.PayErrMsg.indexOf('金额超限')>-1)">拆分发放</el-button>
          </div>
        </el-form-item>
        <el-form-item label="本次发放" prop="IssuedThisMonth" v-if="isSplitPay">
          <el-input v-model="formData.IssuedThisMonth" type="number" style="width:300px" size="small"></el-input>
          <div class="payTips" v-if="formData.IssuedThisMonth">注：剩 {{(info.IssuedThisMonth -  formData.IssuedThisMonth).toFixed(2)}} 元请“新增算薪”选择“其他”类型提交发放</div>
        </el-form-item>
        <el-form-item label="银行卡帐号" prop="BankAccount">
          <el-input v-model="formData.BankAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="DepositBank">
          <el-input v-model="formData.DepositBank" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showEditFailInfo = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmEdit">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import moment from 'moment';
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    e
  } from 'mathjs';
  export default {
    data() {
      return {
        listQuery: {
          pageModel: {
            rows: 10,
            page: 1,
            orderInput: [{
              property: "paymentTime",
              order: 1
            }],
            totalCount: 0
          },
          attrMonth: '',
          employeeName: "",
          cardId: "",
          bankAccount: "",
          phoneNum: "",
          payrollNum: "",
          depositBank: "",
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          processState: 0
        },
        permissionLists: [],
        isBtnLoading: false,
        showDropScreen: -1,
        activeName: '汇总',
        tableData: [],
        roletype: localStorage.loginRoletype,
        multipleSelection: [],
        totalCount: 0,
        loading: false,
        isExping: false,
        isExping2: false,
        info: {},
        isSplitPay: false, //拆分发放
        showEditFailInfo: false, //修改失败人员信息
        formData: {},
        rules: {
          EmployeeName: {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          },
          IncludesTelephoneSubsidy: {
            required: true,
            message: '请输入申请金额',
            trigger: 'blur'
          },
          IssuedThisMonth: {
            required: true,
            message: '请输入实发金额',
            trigger: 'blur'
          },
          BankAccount: {
            required: true,
            message: '请输入银行卡帐号',
            trigger: 'blur'
          },
          DepositBank: {
            required: true,
            message: '请输入开户行',
            trigger: 'blur'
          },
        },
        // 按钮权限参数
        butQuery: {
          path: '/custSalary',
          powerEnName: 'cust'
        },
      }
    },
    created() {
      this.getList();
      this.getButtonPower()
    },
    methods: {
      checkPermission,
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (resmsg) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      currentChange(val) {
        this.listQuery.pageModel.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageModel.page = 1;
        this.listQuery.pageModel.rows = val;
        this.getList();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      searchHandle() {
        this.listQuery.pageModel.page = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        if (this.activeName == '汇总') {
          this.listQuery.processState = 0
        } else if (this.activeName == '发放成功明细') {
          this.listQuery.processState = 10
        } else {
          this.listQuery.processState = 20
        }
        xz.ReportFun(this.listQuery, 'GetGrantPageList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.loading = false;
            this.totalCount = res.data.pageModel.totalCount
          } else {
            this.tableData = [];
            this.loading = false;
            this.totalCount = 0;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        this.getList();
      },
      //下载回单 单个
      downReceiptSingle(row) {
        this.loading = true;
        let d = {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          Id: row.parentId,
          cardID: row.cardID
        }
        xz.downloadEleReceiptPayNum(d).then(res => {
          if (res.status == 'ok') {
            let time = row.CTotalPayrolls < 1000 ? 20000 : 30000;
            this.loadingTxt = time < 30000 ? '生成中...' : '生成中，发薪人数较多，请耐心等待1~3分钟';
            setTimeout(() => {
              this.time = 0;
              this.getpdfcont(res.data)
            }, 10000);
          } else {
            this.loading = false;
            this.loadingTxt = '';
            this.$message.error(res.msg)
          }
        })
      },
      //修改信息
      editFailInfo(row) {
        this.info = row;
        this.isSplitPay = false;
        this.showEditFailInfo = true;
        this.formData = {
          Id: row.Id,
          EmployeeName: row.employeeName, //姓名
          BankAccount: row.bankAccount, //银行卡账号
          DepositBank: row.depositBank, //开户行
        }
      },
      //确认修改
      confirmEdit() {
        this.$refs["formData"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.modifyPaymentFailure(this.formData, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功');
                this.showEditFailInfo = false;
                this.isBtnLoading = false;
                this.getList();
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      expList() {
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        delete d.pageModel;
        xz.ReportExpFun(d, 'ExportGrantPageList').then(res => {
          try {
            var data = new Blob([res], {
              type: "application/vnd.ms-excel;charset=utf-8"
            });
            var downloadUrl = window.URL.createObjectURL(data);
            var anchor = document.createElement("a");
            anchor.href = downloadUrl;
            anchor.download = this.activeName + '列表' + ".xlsx";
            anchor.click();
            window.URL.revokeObjectURL(data);
            this.isExping = false;
          } catch (e) {
            this.isExping = false;
            this.$message.error('导出异常')
          }
        })
      },
      batchDown() {
        if (this.listQuery.attrMonth) {
          let d = {
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
            AttrMonth: this.listQuery.attrMonth
          }
          this.isExping2 = true;
          xz.DownloadEleReceiptByAttrMonth(d).then(res => {
            if (res.status == 'ok') {
              try {
                var r = JSON.parse(res.data);
                const aTag = document.createElement("a");
                aTag.href = r.data;
                aTag.click();
                this.isExping2 = false;
              } catch (e) {
                this.isExping2 = false;
                this.$message.error('下载失败')
              }
            } else {
              this.isExping2 = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.warning('请选择归属月')
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }
</style>
<style>
  .page_custEmp .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_custEmp .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_custEmp .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_custEmp .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_custEmp .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_custEmp .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_custEmp .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_custEmp .el-checkbox__label {
    padding-left: 3px;
  }

  .page_custEmp .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .dia_label_box .el-checkbox.is-bordered.is-checked,
  .dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #19BD92;
  }

  .dia_label_box .el-checkbox {
    border: 1px solid #ddd;
    padding: 2px 3px;
    border-radius: 3px;
    height: auto;
    margin: 5px 20px 0 0;
  }

  .p_resource_module .r_dropDownScreen .el-checkbox__label,
  .dia_label_box .el-checkbox__label {
    padding-left: 3px;
  }
</style>